import React from 'react'
import {Link} from 'react-router-dom'
import '../Css/LoginPage.css'
import TopHeader from '../Header/TopHeader'
import Navbar from '../Header/Navbar'

function Login() {
    return (
        <>
        <TopHeader/>
        <Navbar/>
            <div class="wrapper">
                <div class="container1 p-4">
                    <div class="col-left">
                        <div class="login-text" style={{ marginLeft: "-2rem" }}>
                            <h2 >Compliancekare</h2>
                            <p>
                                File your ITR online in just 4 minutes
                            </p>
                            <div style={{ display: ' flex' }} >

                                <div >
                                    <a class="btn" href="">Google</a>
                                </div>
                                &nbsp; &nbsp;
                                <div >
                                    <a class="btn" href="">Facebook</a>
                                </div>


                            </div>
                        </div>
                    </div>
                    <div class="col-right">
                        <div class="login-form">
                            <h2>Login</h2>
                            <form>
                                <p>
                                    <input type="text" placeholder="Username" required />
                                </p>
                                <p>
                                    <input type="password" placeholder="Password" required />
                                </p>
                                <p>
                                    <a style={{ background: "linear-gradient(105deg, #30909d ,#268c98)  " }}><input class="btn" type="submit" value="Sing In" /></a>
                                </p>
                                <p>
                                    <a href="">Forget password?</a>
                                    <Link to="/Signup"><a href="">Create an account.</a></Link>
                                </p>
                            </form>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default Login